// extracted by mini-css-extract-plugin
export default {"progressWrapper":"ProgressBar_progressWrapper__5ep3j","progressBar":"ProgressBar_progressBar__FTg66"};